module.exports = __webpack_public_path__ + "media/images/backgrounds/shop-fc441ffcee4c06e2bb781ea7a4ded5f749e3a434698567947906074f3f08f7d1.jpg";